import { ViewContext } from 'context/ViewContext'
import { useContext } from 'react'
import Desktop from './Desktop'
import Mobile from './Mobile'

const View = () => {
  const isSmallScreen = useContext(ViewContext)
  return isSmallScreen ? <Mobile /> : <Desktop />
}

export default View
